module.exports = __webpack_public_path__ + "static/img/example4.b0341b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chainmanage/image/example4.jpg
// module id = 710
// module chunks = 1